module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "preface"
    }
  }, [_c('p', {
    staticClass: "chapterTitle1"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage1"
  }, [_c('img', {
    staticStyle: {
      "max-height": "90%"
    },
    attrs: {
      "alt": "image",
      "src": "images/throut.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A sheriff’s deputy was cleaning out the basement of the Missoula County Courthouse one afternoon in the 1970s when he stumbled across a stack of wanted posters dating back to the early 1900s. ")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The nearly 200 documents, some faded and torn, told stories of murder, theft, cheats, broken promises, and daring escapes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Intrigued, the deputy showed the posters to Missoula County Sheriff John C. Moe. Being a career lawman, the sheriff took an immediate interest in the newly found material.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I looked them over and decided they would be of interest to historians,” Moe said. “I looked them over and thought, ‘Well, I’ll put them together in a book.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Moe donated the collection to the Historical Museum at Fort Missoula, in Montana, in 2003, and a selection of the documents is presented here. Sources of information for the introduction, chapter openings, and stories are listed in the bibliography.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "throut1",
      "src": "images/throut1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d19625f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02b_preface.vue
// module id = 66
// module chunks = 0